/* eslint-disable jsx-a11y/anchor-is-valid */

import { Component } from "react";
import ReactDOM from "react-dom";
import axios from "axios";

import { BACKEND_CONFIG } from "../../config/consts";
import Table from "../../common/Table.js";
import { formatDateString } from "../../utils/format";
import ClientBackHeader from "../../components/ClientBackHeader";
import { creatBlobFromBase64 } from "../../utils/utils";

import "../../styles/_datatables.scss";

export default class Documents extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      pages: -1,
      pageSize: 10,
      loading: false,
      clientId: props.match.params.clientId,
      redirectUrl: "",
    };

    this.viewDocument = this.viewDocument.bind(this);
  }

  viewDocument(document) {
    axios
      .get(
        `${BACKEND_CONFIG.apiUrl}documents/${document.ClientId}/files/${document.DocumentId}/content`
      )
      .then(({ data }) => {
        const blob = creatBlobFromBase64(data.Content, data.ContentType);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, data.FileName);
        } else {
          const url = window.URL.createObjectURL(blob);
          if (document.ContentType === "application/pdf") {
            window.open(url);
          } else {
            const a = window.document.createElement("a");
            window.document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = document.FileName;
            a.click();
            setTimeout(() => {
              window.document.body.removeChild(a);
            }, 0);
          }
        }
      });
  }

  render() {
    const columns = [
      {
        title: "Document Name",
        data: "FileName",
      },
      {
        title: "Date Created",
        data: "CreationDate",
        className: "w-100",
        render: (v) => formatDateString(v),
      },
      {
        title: "",
        sortable: false,
        data: "DocumentId",
        className: "btn-column",
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <div className="btn-pair">
              <a
                className="btn btn-default w-60px"
                onClick={() => this.viewDocument(rowData)}
              >
                View
              </a>
            </div>,
            td
          ),
      },
    ];

    const requestUrl =
      BACKEND_CONFIG.apiUrl +
      "documents/" +
      JSON.stringify(this.state.clientId).replace(/"/g, "") +
      "/default";

    return (
      <div>
        <ClientBackHeader
          clientId={this.props.match.params.clientId}
          goBack={() => this.props.history.goBack()}
        />
        <h1 className="page-header">View Documents</h1>
        <Table
          id="docsTable"
          serverSide="true"
          ajax={{
            url: requestUrl,
            type: "GET",
            headers: {
              Authorization: "bearer " + BACKEND_CONFIG.get("auth"),
              "X-AgencyId": BACKEND_CONFIG.get("agencyid"),
            },
            data: (json) => json.data,
          }}
          columns={columns}
          autoWidth="false"
          lengthChange="true"
          pageLength="10"
          paging="true"
          language={{
            emptyTable:
              "<div id='dvNoData' class='center alert alert-info lead'>No documents match search and filter criteria.</div>",

            zeroRecords:
              "<div id='dvNoSearch' class='center alert alert-info lead'>No documents matching that search.</div>",

            loadingRecords: "<b>Please wait - loading...</b>",

            lengthMenu:
              "Show <select id='dlRows' class='center' style = 'width: 60px;'>" +
              "<option value='5'>5</option>" +
              "<option value='10'>10</option>" +
              "<option value='25'>25</option>" +
              "<option value='50'>50</option>" +
              "<option value='100'>100</option>" +
              "</select> documents per page.",
          }}
        />
      </div>
    );
  }
}
